<template>
  <div :class="['home flex-column', programStyle]">
    <div class="content flex-column">
      <div class="review-request-container" v-if="pageType === 'review'">
        <div v-if="multipleReview" class="flex-row request-list">
          <button :class="isFirstRequest ? 'disabled' : ''" :disabled="isFirstRequest" @click="goToPrevious">
            {{ $t('previous') }}
          </button>
          <span>{{ $t('viewing-request', [reviewListIndex + 1, reviewList.length]) }}</span>
          <button :class="isLastRequest ? 'disabled' : ''" :disabled="isLastRequest" @click="goToNext">
            {{ $t('next') }}
          </button>
        </div>
        <div class="request-details flex-column">
          <span class="action-name">{{ $t('review-request') }}</span>
          <div>
            <span class="section-label">{{ $t('request-details') }}</span>
            <ul>
              <li>
                <span>{{ $t('role-type') }}</span> {{ selectedReviewRequest.roleType }}
              </li>
              <li v-if="selectedReviewRequest.roleType === 'Dealer'">
                <span>{{ $t('dealer-code-1') }}</span> {{ selectedReviewRequest.entity }}
              </li>
              <li><span>TID/SID:</span> {{ selectedReviewRequest.userId }}</li>
              <li><span>Name:</span> {{ selectedReviewRequest.firstName }} {{ selectedReviewRequest.lastName }}</li>
              <li><span>Email:</span> {{ selectedReviewRequest.email }}</li>
              <li v-if="selectedReviewRequest.action === 'Add'">
                <span>Role:</span> {{ selectedReviewRequest.newRole }}
              </li>
              <li v-else><span>Role:</span> {{ selectedReviewRequest.oldRole }}</li>
              <li><span>Action:</span> {{ selectedReviewRequest.action }}</li>
              <li v-if="selectedReviewRequest.action === 'Change'">
                <span>{{ $t('new-role') }}</span> {{ selectedReviewRequest.newRole }}
              </li>
              <li>
                <span>{{ $t('request-reason') }}</span> {{ selectedReviewRequest.requestReason }}
              </li>
            </ul>
            <span class="section-label">{{ $t('requested-by') }}</span>
            <ul>
              <li><span>TID/SID:</span> {{ selectedReviewRequest.requestedBy }}</li>
              <li>
                <span>Name:</span> {{ selectedReviewRequest.addedByFirstName }}
                {{ selectedReviewRequest.addedByLastName }}
              </li>
              <li>
                <span>{{ $t('date-of-creation') }}</span> {{ selectedReviewRequest.requestDate | date }}
              </li>
            </ul>
            <div
              class="request-actions-container"
              v-for="request in selectedReviewRequest.requests"
              :key="request.requestNumber"
            >
              <div v-if="request.canReview" class="request-actions">
                <span class="action-name">{{ $t('request-number', [request.requestNumber]) }}</span>
                <ul>
                  <li><span>Domain:</span> {{ request.domainName }}</li>
                  <li v-if="request.roleType === 'BC'">
                    <span>{{ $t('bc-level') }}</span> {{ request.bcName }}
                  </li>
                </ul>
                <span class="section-label">{{ $t('approve-or-deny-request') }}</span>
                <div class="action flex-row">
                  <div class="flex-row radio-container">
                    <button
                      :class="request.status === 'Approved' ? 'radio-selected' : 'radio'"
                      @click="request.status = 'Approved'"
                    >
                      <div v-if="request.status === 'Approved'" class="selected"></div>
                    </button>
                    <p>{{ $t('approve-request') }}</p>
                  </div>
                  <div class="flex-row radio-container">
                    <button
                      :class="request.status === 'Denied' ? 'radio-selected' : 'radio'"
                      @click="request.status = 'Denied'"
                    >
                      <div v-if="request.status && request.status === 'Denied'" class="selected"></div>
                    </button>
                    <p>{{ $t('deny-request') }}</p>
                  </div>
                </div>
                <GInput
                  type="textarea"
                  v-model="request.reviewReason"
                  maxlength="500"
                  :showCount="true"
                  class="input-box"
                  :placeholder="$t('enter-detailed-reason')"
                ></GInput>
              </div>
            </div>
          </div>
          <div class="button-container flex-row">
            <button
              :class="['add', reviewRequestValidation ? '' : 'disabled']"
              :disabled="!reviewRequestValidation"
              @click="reviewRequest"
            >
              {{ $t('submit') }}
            </button>
            <button class="cancel-button" @click="exit">{{ $t('exit') }}</button>
          </div>
        </div>
      </div>
      <div class="add-request-container" v-if="pageType === 'add'">
        <div class="page-content">
          <div class="pageDetails flex-row">
            <span class="action-name">{{ $t('submit-request') }}</span>
            <div v-if="currentStep !== 'page1'" class="information-box">
              <div class="title">
                <span>{{ $t('request-information') }}</span>
              </div>
              <ul class="dealer-details">
                <li v-if="selectedDomains.length > 1">
                  <span>Domain(s):</span>
                  <ul>
                    <li v-for="domain in selectedDomains" :key="domain.abbreviation">{{ domain.name }}</li>
                  </ul>
                </li>
                <li v-else><span>Domain(s):</span> {{ selectedDomains[0].name }}</li>
                <li>
                  <span>{{ $t('role-type') }}</span> {{ request.roleType }}
                </li>
                <li v-if="request.roleType === 'Dealer'">
                  <span>{{ $t('dealer-code-1') }}</span> {{ request.entity }}
                </li>
                <li v-if="request.roleType === 'Dealer'">
                  <span>{{ $t('dealer-name-0') }}</span> {{ request.dealerName }}
                </li>
              </ul>
              <ul v-if="currentStep === 'page3' || currentStep === 'page4'" class="user-details">
                <li><span>TID/SID:</span> {{ request.userId }}</li>
                <li>
                  <span>{{ $t('first-name-0') }}</span> {{ request.firstName }}
                </li>
                <li>
                  <span>{{ $t('last-name-0') }}</span> {{ request.lastName }}
                </li>
                <li><span>Email:</span> {{ request.email }}</li>
              </ul>
            </div>
          </div>
          <div class="page1 user-type" v-if="currentStep === 'page1'">
            <div>
              <span class="step-number">{{ $t('step-1-of-4') }}</span>
              <span class="section-label">{{ $t('select-a-role-type') }}</span>
              <Multiselect
                v-model="request.roleType"
                :options="rolesByDomain"
                class="multiselect single"
                :placeholder="$t('select-a-role-type-1')"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
              <div v-if="request.roleType && request.roleType === 'Dealer'" class="entity">
                <div class="custom-input flex-row" :class="[helperTextError ? 'required' : '']">
                  <input placeholder="Enter dealer code" v-model="request.entity" />
                  <span class="custom-input-buttons flex-row">
                    <span
                      class="edit-button"
                      :class="['add', entityValidation ? '' : 'disabled']"
                      @click="clearEntity"
                      >{{ $t('clear') }}</span
                    >
                  </span>
                </div>
                <span v-if="helperTextError" class="helper-text_error">{{ $t('no-dealer-code-found') }}</span>
              </div>
              <div v-if="request.roleType" class="attribute-selection">
                <span class="section-label">{{ $t('select-domains') }}</span>
                <Multiselect
                  v-model="selectedDomains"
                  :options="domainOptions"
                  class="multiselect single"
                  :placeholder="$t('select-domains-1')"
                  :showLabels="false"
                  :allow-empty="true"
                  track-by="name"
                  label="name"
                  :multiple="true"
                  :close-on-select="false"
                  @select="onSelect($event)"
                  @remove="onRemove($event)"
                >
                  <template v-if="values.length > 3" slot="selection" slot-scope="{ values, search, isOpen }"
                    ><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{
                      $t('options-selected', [values.length])
                    }}</span></template
                  >
                  <span class="checkbox-label" slot="option" slot-scope="scope">
                    <input type="checkbox" v-model="scope.option.checked" @focus.prevent :key="scope.option.label" />
                    <span>{{ scope.option.name }}</span>
                  </span>
                </Multiselect>
              </div>
              <div v-if="request.roleType && request.roleType === 'BC'" class="attribute-selection">
                <span class="section-label">{{ $t('bc-level-0') }}</span>
                <Multiselect
                  v-model="request.bc"
                  :options="bcOptions"
                  class="multiselect single"
                  :placeholder="$t('select-a-bc-level')"
                  :showLabels="false"
                  :allow-empty="false"
                  track-by="fullBCName"
                  label="fullBCName"
                ></Multiselect>
              </div>
            </div>
          </div>
          <div class="page2 user-details flex-column" v-else-if="currentStep === 'page2'">
            <div>
              <span class="step-number">{{ $t('step-2-of-4') }}</span>
              <span class="section-label">{{ $t('request-details-0') }}</span>
              <ul>
                <li v-if="request.roleType === 'Dealer'">* SID:</li>
                <li v-else>* TID:</li>
                <li class="custom-input flex-row" :class="[helperTextError || searchError ? 'required' : '']">
                  <input v-if="request.roleType === 'Dealer'" placeholder="Enter SID" v-model="request.userId" />
                  <input v-else placeholder="Enter TID" v-model="request.userId" />
                  <span class="custom-input-buttons flex-row">
                    <span
                      class="edit-button"
                      :class="['add', isValidUser ? '' : 'disabled']"
                      @click="searchErrorCheck"
                      >{{ $t('search') }}</span
                    ><span class="separator">|</span
                    ><span
                      class="edit-button"
                      :class="['add', isValidUser ? '' : 'disabled']"
                      @click="clearUserDetails"
                      >{{ $t('clear') }}</span
                    >
                  </span>
                </li>
                <li v-if="helperTextSuccess" class="helper-text_success">
                  <span v-if="request.roleType === 'Dealer'">{{ $t('account-found-sid') }}</span
                  ><span v-else>{{ $t('account-found-tid') }}</span>
                </li>
                <li v-if="searchError" class="helper-text_error">
                  <span v-if="request.roleType === 'Dealer'">{{ $t('sid-required') }}</span
                  ><span v-else>{{ $t('tid-required') }}</span>
                </li>
                <li v-if="helperTextError" class="helper-text_error">
                  <span v-if="request.roleType === 'Dealer'">{{ $t('no-accounts-found-sid') }}</span
                  ><span v-else>{{ $t('no-accounts-found-tid') }}</span>
                </li>
                <li v-if="helperTextError" class="helper-text_error">
                  <span v-if="request.roleType === 'Dealer'">{{ $t('create-new-account-sid') }}</span
                  ><span v-else>{{ $t('create-new-account-tid') }}</span>
                </li>
                <li>{{ $t('first-name-1') }}</li>
                <li class="custom-input flex-row" :class="[helperTextError ? 'required' : '']">
                  <input
                    :class="[helperTextError ? '' : 'disabled']"
                    required
                    v-model="request.firstName"
                    :placeholder="[helperTextError ? 'Enter first name' : '']"
                  />
                  <span v-if="helperTextError && request.firstName" class="custom-input-buttons flex-row">
                    <span class="edit-button" @click="request.firstName = ''">{{ $t('clear') }}</span>
                  </span>
                </li>
                <li>{{ $t('last-name-1') }}</li>
                <li class="custom-input flex-row" :class="[helperTextError ? 'required' : '']">
                  <input
                    :class="[helperTextError ? '' : 'disabled']"
                    required
                    v-model="request.lastName"
                    :placeholder="[helperTextError ? 'Enter last name' : '']"
                  />
                  <span v-if="helperTextError && request.lastName" class="custom-input-buttons flex-row">
                    <span class="edit-button" @click="request.lastName = ''">{{ $t('clear') }}</span>
                  </span>
                </li>
                <li>{{ $t('email-address') }}</li>
                <li class="custom-input flex-row">
                  <input
                    :class="[helperTextError ? '' : 'disabled']"
                    required
                    v-model="request.email"
                    :placeholder="[helperTextError ? 'Enter email' : '']"
                  />
                  <span v-if="helperTextError && request.email" class="custom-input-buttons flex-row">
                    <span class="edit-button" @click="request.email = ''">{{ $t('clear') }}</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="page3 request-details flex-column" v-else-if="currentStep === 'page3'">
            <div>
              <span class="step-number">{{ $t('step-3-of-4') }}</span>
              <span id="section-title">{{ $t('current-roles') }}</span>
              <div class="current-roles-section">
                <div class="lists flex-row">
                  <div class="domains-list">
                    <span class="list-title">domain(s):</span>
                    <ul>
                      <li v-for="role in currentRoles" :key="role.roleId">{{ role.fullDomainName }}</li>
                    </ul>
                  </div>
                  <div class="roles-list">
                    <span class="list-title">role(s):</span>
                    <ul>
                      <li v-for="role in currentRoles" :key="role.roleId">{{ role.role }}</li>
                    </ul>
                  </div>
                  <div v-if="displayBcList" class="bc-list">
                    <span class="list-title">BC Level(s):</span>
                    <ul>
                      <li v-for="role in currentRoles" :key="role.roleId">
                        <span v-if="role.bc !== null && role.fullBCName !== null">{{ role.fullBCName }}</span>
                        <span v-else>Not Available</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <span class="section-label">{{ $t('request-action') }}</span>
              <Multiselect
                v-model="request.action"
                :options="roleActions"
                class="multiselect single"
                :placeholder="$t('select-an-action')"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
              <span class="helper-text_notify">{{ $t('revoke-or-change-alert') }}</span>
            </div>
          </div>
          <div class="page4 role-selection" v-else-if="currentStep === 'page4'">
            <div>
              <span class="step-number">{{ $t('step-4-of-4') }}</span>
              <div class="action-add-role" v-if="request.action && request.action === 'Add' && rolesByDomainAndType">
                <span v-if="request.action && request.action === 'Add'" class="section-label">{{
                  $t('add-role')
                }}</span>
                <Multiselect
                  v-model="request.newRole"
                  :options="rolesByDomainAndType"
                  class="multiselect single"
                  :placeholder="$t('select-a-role')"
                  :showLabels="false"
                  :allow-empty="false"
                ></Multiselect>
              </div>
              <div
                class="action-change-role"
                v-if="request.action && request.action !== 'Add' && changeRoleDropdownOptions"
              >
                <span v-if="request.action && request.action === 'Revoke'" class="section-label">{{
                  $t('revoke-role')
                }}</span>
                <span v-if="request.action && request.action === 'Change'" class="section-label">{{
                  $t('change-role')
                }}</span>
                <div class="flex-row">
                  <Multiselect
                    v-model="request.oldRole"
                    :options="changeRoleDropdownOptions.firstRolesList"
                    class="multiselect single"
                    :placeholder="$t('select-a-role')"
                    :showLabels="false"
                    :allow-empty="false"
                  ></Multiselect>
                  <p v-if="request.action === 'Change'">{{ $t('to') }}</p>
                  <Multiselect
                    v-if="request.action === 'Change'"
                    v-model="request.newRole"
                    :options="changeRoleDropdownOptions.secondRolesList"
                    class="multiselect single"
                    :placeholder="$t('select-a-role')"
                    :showLabels="false"
                    :allow-empty="false"
                  ></Multiselect>
                </div>
              </div>
              <GInput
                type="textarea"
                v-model="request.requestReason"
                maxlength="500"
                :showCount="true"
                class="input-box"
                :placeholder="$t('enter-a-reason')"
              ></GInput>
              <span class="section-label-custom">{{ $t('priority-0') }}</span>
              <Multiselect
                v-model="request.priority"
                :options="priorityLevels"
                class="multiselect single"
                :placeholder="$t('select-priority-level')"
                :showLabels="false"
                :allow-empty="false"
              ></Multiselect>
            </div>
          </div>
        </div>
        <div class="button-container flex-row">
          <div class="nav-buttons">
            <button v-if="currentStep !== 'page1'" class="back-button" @click="previousPage">{{ $t('back') }}</button>
            <button
              v-if="this.currentStep === 'page1' && this.request.roleType === 'Dealer'"
              :class="['add', pageOneValidation ? '' : 'disabled']"
              :disabled="!pageOneValidation"
              @click="validateEntity"
            >
              {{ $t('next') }}
            </button>
            <button
              v-if="this.currentStep === 'page1' && this.request.roleType !== 'Dealer'"
              :class="['add', pageOneValidation ? '' : 'disabled']"
              :disabled="!pageOneValidation"
              @click="nextPage() + getProfileDetails()"
            >
              {{ $t('next') }}
            </button>
            <button
              v-if="this.currentStep === 'page2' && this.helperTextError"
              :class="['add', pageTwoValidation ? '' : 'disabled']"
              :disabled="!pageTwoValidation"
              @click="
                getUserById() +
                  getRolesByDomainAndType(request) +
                  changeRoleOptions(request) +
                  showBcList() +
                  nextPage()
              "
            >
              {{ $t('save-and-continue') }}
            </button>
            <button
              v-if="this.currentStep === 'page2' && !this.helperTextError"
              :class="['add', pageTwoValidation ? '' : 'disabled']"
              :disabled="!pageTwoValidation"
              @click="getRolesByDomainAndType(request) + changeRoleOptions(request) + showBcList() + nextPage()"
            >
              {{ $t('next') }}
            </button>
            <button
              v-if="this.currentStep === 'page3' && request.action === 'Add'"
              :class="['add', pageThreeValidation ? '' : 'disabled']"
              :disabled="!pageThreeValidation"
              @click="nextPage"
            >
              {{ $t('next') }}
            </button>
            <button
              v-if="this.currentStep === 'page3' && request.action !== 'Add'"
              :class="['add', pageThreeValidation ? '' : 'disabled']"
              :disabled="!pageThreeValidation"
              @click="changeRoleOptions(request) + nextPage()"
            >
              {{ $t('next') }}
            </button>
            <button
              v-if="this.currentStep === 'page4'"
              :class="['add', pageFourValidation ? '' : 'disabled']"
              :disabled="!pageFourValidation"
              @click="addRequest"
            >
              {{ $t('submit') }}
            </button>
          </div>
          <button class="cancel-button" @click="isModalOpen = true">{{ $t('cancel-request') }}</button>
        </div>
      </div>
      <div class="edit-request-container" v-else-if="pageType === 'edit'">
        <div class="request-details flex-column">
          <span v-if="showViewPage" class="action-name">{{ $t('view-request') }}</span>
          <span v-else class="action-name">{{ $t('edit-request') }}</span>
          <div>
            <span class="section-label">{{ $t('request-details') }}</span>
            <ul>
              <li>
                <span>{{ $t('role-type') }}</span> {{ selectedRequest.roleType }}
              </li>
              <li v-if="selectedRequest.roleType === 'Dealer'">
                <span>{{ $t('dealer-code-1') }}</span> {{ selectedRequest.entity }}
              </li>
              <li><span>TID/SID:</span> {{ selectedRequest.userId }}</li>
              <li><span>Name:</span> {{ selectedRequest.firstName }} {{ selectedRequest.lastName }}</li>
              <li><span>Email:</span> {{ selectedRequest.email }}</li>
              <li v-if="selectedRequest.action === 'Add'"><span>Role:</span> {{ selectedRequest.newRole }}</li>
              <li v-else><span>Role:</span> {{ selectedRequest.oldRole }}</li>
              <li><span>Action:</span> {{ selectedRequest.action }}</li>
              <li v-if="selectedRequest.action === 'Change'">
                <span>{{ $t('new-role') }}</span> {{ selectedRequest.newRole }}
              </li>
              <li>
                <span>{{ $t('request-reason') }}</span> {{ selectedRequest.requestReason }}
              </li>
            </ul>
            <span class="section-label">{{ $t('requested-by') }}</span>
            <ul>
              <li><span>TID/SID:</span> {{ selectedRequest.requestedBy }}</li>
              <li>
                <span>Name:</span> {{ selectedRequest.addedByFirstName }}
                {{ selectedRequest.addedByLastName }}
              </li>
              <li>
                <span>{{ $t('date-of-creation') }}</span> {{ selectedRequest.requestDate | date }}
              </li>
            </ul>
            <div class="request-actions" v-for="(selectedRequest, index) in selectedRequestArray" :key="index">
              <span class="action-name">{{ $t('request-number', [index + 1]) }}</span>
              <ul>
                <li><span>Domain:</span> {{ selectedRequest.domainName }}</li>
                <li v-if="selectedRequest.roleType === 'BC'">
                  <span>{{ $t('bc-level') }}</span> {{ selectedRequest.bc }}
                </li>
                <li><span>Status:</span> {{ selectedRequest.status }}</li>
                <li>
                  <span>{{ $t('review-reason') }}</span> {{ selectedRequest.reviewReason }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span class="section-label">{{ $t('request-action') }}</span>
        <Multiselect
          v-model="selectedRequest.action"
          :options="roleActions"
          class="multiselect single"
          :placeholder="$t('select-role')"
          :showLabels="false"
          :allow-empty="false"
          :disabled="true"
        ></Multiselect>
        <span class="section-label">{{ $t('request-role') }}</span>
        <div class="action-container">
          <Multiselect
            v-if="selectedRequest.action && selectedRequest.action === 'Add' && rolesByDomainAndType"
            v-model="selectedRequest.newRole"
            :options="rolesByDomainAndType"
            class="multiselect single"
            :placeholder="$t('select-role')"
            :showLabels="false"
            :allow-empty="false"
            :disabled="true"
          ></Multiselect>
          <Multiselect
            v-if="selectedRequest.action && selectedRequest.action === 'Revoke' && rolesByDomainAndType"
            v-model="selectedRequest.oldRole"
            :options="rolesByDomainAndType"
            class="multiselect single"
            :placeholder="$t('select-role')"
            :showLabels="false"
            :allow-empty="false"
            :disabled="true"
          ></Multiselect>
          <div
            class="flex-row action-change-role"
            v-if="selectedRequest.action && selectedRequest.action === 'Change' && changeRoleDropdownOptions"
          >
            <Multiselect
              v-model="selectedRequest.oldRole"
              :options="changeRoleDropdownOptions.firstRolesList"
              class="multiselect single"
              :placeholder="$t('select-role')"
              :showLabels="false"
              :allow-empty="false"
              :disabled="true"
            ></Multiselect>
            <p>{{ $t('to') }}</p>
            <Multiselect
              v-model="selectedRequest.newRole"
              :options="changeRoleDropdownOptions.secondRolesList"
              class="multiselect single"
              :placeholder="$t('select-role')"
              :showLabels="false"
              :allow-empty="false"
              :disabled="true"
            ></Multiselect>
          </div>
          <textarea v-if="showViewPage" id="request-reason-box" readonly v-model="selectedRequest.requestReason" />
          <GInput
            v-else
            type="textarea"
            v-model="selectedRequest.requestReason"
            maxlength="500"
            :showCount="true"
            class="input-box"
            :placeholder="$t('enter-detailed-reason')"
            :disabled="showViewPage"
          ></GInput>
        </div>
        <div class="button-container flex-row">
          <button
            v-if="!showViewPage"
            @click="editRequest"
            :class="['add', editRequestValidation ? '' : 'disabled']"
            :disabled="!editRequestValidation"
          >
            {{ $t('save') }}
          </button>
          <button v-if="showViewPage" @click="exit">{{ $t('back') }}</button>
          <button v-else class="cancel-button" @click="isModalOpen = true">{{ $t('cancel') }}</button>
        </div>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">{{ $t('confirm-cancellation') }}</span>
          <span class="modal-text">{{ $t('cancel-request-alert') }}</span>
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="exit">{{ $t('confirm') }}</button>
          <button class="cancel-button" @click="isModalOpen = false">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import GInput from '@/components/GComponents/GInput.vue';
import Modal from '@/components/Modal.vue';

export default {
  name: 'RoleRequests',
  components: {
    Multiselect,
    GInput,
    Modal,
  },
  props: {
    selectedRequestArray: {
      type: Array,
    },
    pageType: {
      type: String,
    },
    reviewList: {
      type: Array,
    },
    multipleReview: {
      type: Boolean,
    },
    showViewPage: {
      type: Boolean,
    },
  },
  data() {
    return {
      request: {
        domain: '',
        domains: [],
        dealerName: '',
        bc: '',
        bcs: [],
        entity: '',
        userId: '',
        roleType: '',
        oldRole: '',
        newRole: '',
        action: '',
        requestReason: '',
        firstName: '',
        lastName: '',
        email: '',
        priority: '',
      },
      selectedRequest: null,
      domainOptions: [],
      bcOptions: [],
      selectedDomains: null,
      selectedBcs: null,
      rolesByDomain: [],
      rolesByDomainAndType: [],
      currentRoles: [],
      steps: ['page1', 'page2', 'page3', 'page4'],
      currentStep: 'page1',
      currentStepIndex: 0,
      changeRoleDropdownOptions: null,
      reviewId: null,
      isValidEntity: false,
      selectedReviewRequest: {
        domain: null,
        bc: null,
        entity: null,
        userId: null,
        roleType: null,
        oldRole: null,
        newRole: null,
        action: null,
        requestReason: null,
        firstName: null,
        lastName: null,
        email: null,
        requestedBy: null,
        requestDate: null,
        addedByFirstName: null,
        addedByLastName: null,
        overAllStatus: null,
        requests: [],
      },
      priorityLevels: ['Low', 'Normal', 'High'],
      roleActions: [],
      helperTextSuccess: false,
      helperTextError: false,
      isModalOpen: false,
      searchError: false,
      displayBcList: false,
    };
  },
  methods: {
    nextPage() {
      this.currentStepIndex += 1;
      this.currentStep = this.steps[this.currentStepIndex];
    },
    previousPage() {
      this.currentStepIndex -= 1;
      this.currentStep = this.steps[this.currentStepIndex];
    },
    addRequest() {
      const loader = this.$loading.show();

      const params = {
        domains: this.request.domains,
        bc: this.request.bc.bc,
        entity: this.request.entity,
        userId: this.request.userId,
        roleType: this.request.roleType,
        oldRole: this.request.oldRole,
        newRole: this.request.newRole,
        action: this.request.action,
        requestReason: this.request.requestReason,
        priority: this.request.priority,
      };

      this.$store
        .dispatch('addRequest', params)
        .then((res) => {
          if (res) {
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('request-successfully-submitted'),
            });
            this.exit();
          }
        })
        .catch((error) => {
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error.data.error,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    searchErrorCheck() {
      const { userId } = this.request;

      if (this.request.roleType === 'Dealer' && (userId.startsWith('S') || userId.startsWith('s'))) {
        this.getUserById();
      } else if (this.request.roleType !== 'Dealer' && (userId.startsWith('T') || userId.startsWith('t'))) {
        this.getUserById();
      } else {
        this.searchError = true;
      }
    },
    getUserById() {
      const loader = this.$loading.show();

      const { domain } = this;
      const { userId, firstName, lastName, email, roleType, entity } = this.request;

      this.$store
        .dispatch('getUserByIdField', {
          domain,
          userId,
          firstName,
          lastName,
          email,
          roleType,
          entity,
        })
        .then((res) => {
          this.helperTextSuccess = true;
          this.updateRequestDetails(res.user);
          this.currentRoles = res.user.roles;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
            this.helperTextError = true;
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setRoleActions() {
      if (this.changeRoleDropdownOptions.firstRolesList.length > 0) {
        // Add Change and Revoke options if user has existing role(s)
        this.roleActions.push('Change', 'Revoke');
        const tempSet = [...new Set(this.roleActions)];
        this.roleActions = Array.from(tempSet);
      }
    },
    updateRequestDetails(user) {
      this.request.userId = user.uid;
      this.request.firstName = user.firstName;
      this.request.lastName = user.lastName;
      this.request.email = user.email;
      this.request.domain = this.domain;
    },
    exit() {
      this.$emit('exit');
    },
    editRequest() {
      const loader = this.$loading.show();

      const { id: requestId } = this.selectedRequest;

      const params = {
        userId: this.selectedRequest.userId,
        requestReason: this.selectedRequest.requestReason,
      };

      this.$store
        .dispatch('editRequest', { requestId, params })
        .then((res) => {
          if (res) {
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('request-successfully-saved'),
            });
            this.exit();
          }
        })
        .catch((error) => {
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error.data.error,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    setSingleRequest(request) {
      let counterSingle = 0;
      let counterMultiple = 0;

      request.forEach((subRequest) => {
        const singleReviewObject = {
          requestNumber: (counterSingle += 1),
        };
        const multipleReviewObject = {
          domainName: subRequest.fullDomainName,
          requestedBy: subRequest.addedBy,
          requestDate: subRequest.createdAt,
          bcName: subRequest.fullBCName,
          requestNumber: (counterMultiple += 1),
        };
        if (this.multipleReview) {
          Object.assign(subRequest, multipleReviewObject);
        } else {
          Object.assign(subRequest, singleReviewObject);
        }
      });

      Object.assign(this.selectedReviewRequest, request[0]);
      this.selectedReviewRequest.requests.push(...request);
    },
    setOverallStatus() {
      const reviewableRequests = [];
      const requestStatuses = [];

      // Get all reviewable requests
      this.selectedReviewRequest.requests.forEach((request) => {
        if (request.canReview) {
          reviewableRequests.push(request);
        }
      });

      // Get statuses of all reviewable requests
      this.selectedReviewRequest.requests.forEach((request) => {
        if (request.canReview && request.status !== 'Pending') {
          requestStatuses.push(request.status);
        }
      });

      const allApproved = (arr) => arr.every((status) => status === 'Approved');
      const allDenied = (arr) => arr.every((status) => status === 'Denied');

      // Set overall status of the selected review request
      if (
        requestStatuses.length > 0 &&
        reviewableRequests.length === requestStatuses.length &&
        allApproved(requestStatuses)
      ) {
        this.selectedReviewRequest.overAllStatus = 'Approved';
      } else if (
        requestStatuses.length > 0 &&
        reviewableRequests.length === requestStatuses.length &&
        allDenied(requestStatuses)
      ) {
        this.selectedReviewRequest.overAllStatus = 'Denied';
      } else if (requestStatuses.length > 0 && reviewableRequests.length === requestStatuses.length) {
        this.selectedReviewRequest.overAllStatus = 'Partial';
      } else {
        this.selectedReviewRequest.overAllStatus = 'Pending';
      }
    },
    getSingleRequest(id) {
      const loader = this.$loading.show();

      this.isModalOpen = false;
      this.$store
        .dispatch('getSingleRequest', {
          id,
        })
        .then((res) => {
          this.setSingleRequest(res.data.singleRequest);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    reviewRequest() {
      const loader = this.$loading.show();

      const { id } = this.selectedReviewRequest;

      const params = [];

      this.selectedReviewRequest.requests.forEach((request) => {
        const tempObj = {
          domain: request.domain,
          bc: request.bc,
          status: request.status,
          reviewReason: request.reviewReason,
        };
        params.push(tempObj);
      });

      this.$store
        .dispatch('reviewRequest', { id, params })
        .then((res) => {
          if (res) {
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('request-successfully-submitted'),
            });
            if (this.multipleReview && !this.isLastRequest) {
              this.goToNext();
            } else {
              this.exit();
            }
          }
        })
        .catch((error) => {
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error.data.error,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMultipleDomains() {
      const loader = this.$loading.show();

      const { roleType } = this.request;

      this.$store
        .dispatch('getMultipleDomains', { roleType })
        .then((res) => {
          this.setDomainOptions(res);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setDomainOptions(domains) {
      domains.forEach((domain) => {
        const tempObj = { checked: false, name: domain.fullDomainName, abbreviation: domain.domain, type: 'Domain' };
        this.domainOptions.push(tempObj);
      });
    },
    onSelect(option) {
      // WIP
      // if (option.label === 'Select all') {
      //   this.bcOptions.forEach((item) => {
      //     item.checked = true;
      //   });
      // }
      if (option.type === 'Domain') {
        const index = this.domainOptions.findIndex((item) => item.abbreviation === option.abbreviation);
        this.domainOptions[index].checked = true;
        this.request.domains.push(option.abbreviation);
      } else {
        const index = this.bcOptions.findIndex((item) => item.abbreviation === option.abbreviation);
        this.bcOptions[index].checked = true;
        this.request.bcs.push(option.abbreviation);
      }
    },
    onRemove(option) {
      if (option.type === 'Domain') {
        const index = this.domainOptions.findIndex((item) => item.abbreviation === option.abbreviation);
        this.domainOptions[index].checked = false;
        this.request.domains.splice(index, 1);
      } else {
        const index = this.bcOptions.findIndex((item) => item.abbreviation === option.abbreviation);
        this.bcOptions[index].checked = false;
        this.request.bcs.splice(index, 1);
      }
    },
    getBcLevels() {
      const loader = this.$loading.show();

      const domains = this.request.domains.toString();

      this.$store
        .dispatch('getBcLevels', { domains })
        .then((res) => {
          this.bcOptions = res;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getRolesByDomain() {
      const loader = this.$loading.show();

      const { domain } = this;

      this.$store
        .dispatch('getRolesByDomain', { domain })
        .then((res) => {
          this.rolesByDomain = res.roleTypes;
          this.loader.hide();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getRolesByDomainAndType(request) {
      const loader = this.$loading.show();

      const { roleType, userId, entity, bcs } = request;

      const domains = this.request.domains.toString();

      this.$store
        .dispatch('getRolesByDomainAndType', { roleType, userId, domains, entity, bcs })
        .then((res) => {
          this.rolesByDomainAndType = res.allRoles;
          // Include Add option for dropdown if user has available role(s)
          if (this.rolesByDomainAndType.length > 0) {
            this.roleActions.push('Add');
            const tempSet = [...new Set(this.roleActions)];
            this.roleActions = Array.from(tempSet);
          }
          this.loader.hide();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    changeRoleOptions(request) {
      const loader = this.$loading.show();

      const { roleType, userId, entity } = request;

      const domains = this.request.domains.toString();

      this.$store
        .dispatch('changeRoleOptions', { domains, userId, roleType, entity })
        .then((res) => {
          this.changeRoleDropdownOptions = res;
          this.setRoleActions();
          this.loader.hide();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    goToNext() {
      if (!this.isLastRequest) {
        this.reviewId = this.reviewList[this.reviewListIndex + 1];
      }
    },
    goToPrevious() {
      if (!this.isFirstRequest) {
        this.reviewId = this.reviewList[this.reviewListIndex - 1];
      }
    },
    clearUserDetails() {
      const resetObject = {
        userId: '',
        firstName: '',
        lastName: '',
        email: '',
      };
      Object.assign(this.request, resetObject);
      this.searchError = false;
      this.helperTextSuccess = false;
      this.helperTextError = false;
      this.roleOptions = [];
    },
    goToPrograms() {
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$router.push({
        name: 'Programs',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    goToDealersList() {
      this.$router.push({
        name: 'Dealer-List',
      });
      this.$store.state.activeNavTab = this.activeNavBar[1];
    },
    validateEntity() {
      const loader = this.$loading.show();

      const { roleType: roletype, entity } = this.request;
      const domains = this.request.domains.toString();

      this.$store
        .dispatch('validateEntity', {
          domains,
          roletype,
          entity,
        })
        .then((res) => {
          if (res) {
            this.isValidEntity = true;
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('valid-dealer-code'),
            });
            this.nextPage();
            this.getProfileDetails();
          }
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
            this.helperTextError = true;
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    clearEntity() {
      this.isValidEntity = false;
      this.request.entity = '';
    },
    getProfileDetails() {
      const loader = this.$loading.show();

      const { domain } = this;
      const { entity } = this.request;

      this.$store
        .dispatch('getProfileDetails', {
          domain,
          entity,
        })
        .then((res) => {
          if (res) {
            this.request.dealerName = res.data.curUserDetails.dealerName;
          }
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    showBcList() {
      const isBcRoleType = (role) => role.fullBCName !== null && role.bc !== null;
      this.displayBcList = this.currentRoles.some(isBcRoleType);
    },
  },
  computed: {
    ...mapState('global', ['programName', 'programStyle']),
    ...mapState(['activeNavTab']),
    ...mapState({
      domain: (state) => state.global.programName,
    }),
    reviewListIndex() {
      return this.reviewList.findIndex((item) => item === this.reviewId);
    },
    isFirstRequest() {
      if (this.reviewListIndex === 0) {
        return true;
      }
      return false;
    },
    isLastRequest() {
      if (this.reviewListIndex === this.reviewList.length - 1) {
        return true;
      }
      return false;
    },
    pageOneValidation() {
      if (this.request.domains.length > 0 && this.request.roleType) {
        if (this.request.roleType === 'Dealer' && this.request.entity) {
          return true;
        }
        if (this.request.roleType === 'BC' && this.request.bc) {
          return true;
        }
        if (this.request.roleType !== 'BC' && this.request.roleType !== 'Dealer') {
          return true;
        }
      }
      return false;
    },
    isValidUser() {
      if (this.request.userId || (this.request.firstName && this.request.lastName) || this.request.email) {
        return true;
      }
      return false;
    },
    pageTwoValidation() {
      if (this.request.userId && this.request.firstName && this.request.lastName) {
        if (this.request.roleType === 'Dealer' && this.request.userId.startsWith('S')) {
          return true;
        }
        if (this.request.roleType !== 'Dealer' && this.request.userId.startsWith('T')) {
          return true;
        }
        return false;
      }
      return false;
    },
    pageThreeValidation() {
      if (this.request.roleType && this.request.domain && this.request.action) {
        return true;
      }
      return false;
    },
    pageFourValidation() {
      if (this.request.action === 'Add') {
        if (this.request.newRole && this.request.requestReason && this.request.priority) {
          return true;
        }
        return false;
      }
      if (this.request.action === 'Revoke') {
        if (this.request.oldRole && this.request.requestReason && this.request.priority) {
          return true;
        }
        return false;
      }
      if (this.request.oldRole && this.request.newRole && this.request.requestReason && this.request.priority) {
        return true;
      }
      return false;
    },
    userIdValidation() {
      if (this.request.userId) {
        return true;
      }
      return false;
    },
    entityValidation() {
      if (this.request.entity) {
        return true;
      }
      return false;
    },
    editRequestValidation() {
      if (
        this.selectedRequest.roleType &&
        this.selectedRequest.userId &&
        this.selectedRequest.action &&
        this.selectedRequest.requestReason &&
        this.selectedRequest.overAllStatus === 'Active'
      ) {
        if (this.selectedRequest.action === 'Change' || this.selectedRequest.action === 'Revoke') {
          if (this.selectedRequest.oldRole) {
            return true;
          }
          return false;
        }
        if (this.selectedRequest.action === 'Add') {
          if (this.selectedRequest.newRole) {
            return true;
          }
          return false;
        }
      }
      return false;
    },
    reviewRequestValidation() {
      this.setOverallStatus();
      if (this.selectedReviewRequest && this.selectedReviewRequest.overAllStatus !== 'Pending') {
        return true;
      }
      return false;
    },
  },
  watch: {
    reviewId() {
      if (this.pageType === 'review' && this.multipleReview) {
        this.selectedReviewRequest.requests = [];
        this.getSingleRequest(this.reviewId);
      }
    },
    'request.entity': function () {
      this.helperTextError = false;
    },
    'request.userId': function () {
      this.searchError = false;
      if (this.helperTextSuccess || this.helperTextError) {
        this.clearUserDetails();
      }
      this.helperTextError = false;
      this.helperTextSuccess = false;
    },
    'request.roleType': function () {
      this.domainOptions = [];
      this.selectedDomains = null;
      this.request.domains = [];
      this.bcOptions = [];
      this.request.entity = '';
      this.request.bc = '';
      this.getMultipleDomains();
    },
    'request.domains': function () {
      this.getBcLevels();
    },
  },
  created() {
    if (this.reviewList && this.reviewList.length > 0) {
      this.reviewId = this.reviewList[0];
    }
    if (this.pageType === 'add' && this.domain) {
      this.getRolesByDomain();
    }
    if (this.pageType === 'edit' && this.domain) {
      this.selectedRequest = this.selectedRequestArray[0];
    }
    if (this.pageType === 'review' && !this.multipleReview) {
      this.setSingleRequest(this.selectedRequestArray);
    }
    if (this.selectedRequest && this.selectedRequest.roleType && !this.selectedRequest.canReview) {
      if (this.setMultipleRequest.action === 'Change') {
        this.changeRoleOptions(this.selectedRequest);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    list-style-type: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li {
      cursor: pointer;
    }
    li:last-child {
      cursor: default;
      font-weight: bold;
    }
  }
  button:hover {
    text-decoration: underline;
  }
}
.content {
  height: 100%;
  flex-wrap: wrap;
  margin: 30px 30px 45px;
  p {
    font-size: 18px;
    color: $primary-black;
  }
  .sub-title {
    text-align: left;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .flexRow {
    display: flex;
    margin-top: 20px;
    input {
      margin-left: 20px;
    }
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .small-title {
    color: black;
    font-size: 20px;
    margin-right: 20px;
  }
  .setup-row-1 {
    margin: 15px 0px 20px 0px;
  }
  .multiselect {
    .checkbox-label {
      display: block;
      margin: 0;
      padding: 0;
      input {
        height: 17px;
        width: 17px;
      }
      span {
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .multiselect__single {
      font-size: 18px;
    }
  }
  .button-container {
    margin-top: 45px;
    button {
      margin-right: 20px;
    }
  }
  ul {
    list-style-type: none;
    padding-left: 0px;
    li {
      margin-left: 0;
    }
  }
  input {
    outline: 0;
    &:read-only {
      opacity: 0.5;
    }
  }
}
.above-table {
  padding: 0 40px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 35px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}
.table-descriptors {
  justify-content: space-between;
  font-size: 24px;
  align-items: center;
  .right {
    display: flex;
    input {
      margin-right: 20px;
    }
  }
}
.table-container {
  margin-top: 50px;
}
.action-name {
  font-size: 18px !important;
  text-transform: uppercase;
  font-weight: bold;
}
.cancel-button,
.back-button {
  background-color: $primary-white;
  border: 1px solid $primary;
  color: $primary;
}
.helper-text {
  font-size: 14px;
  color: $primary-black;
  &_success {
    color: #008716 !important;
    span {
      color: #008716 !important;
      font-size: 14px !important;
    }
  }
  &_error {
    color: red !important;
    font-size: 14px !important;
    span {
      color: red !important;
      font-size: 14px !important;
    }
  }
  &_notify {
    color: $primary-black;
    opacity: 0.5 !important;
    font-size: 14px !important;
  }
}
.add-request-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .information-box {
    position: absolute;
    right: 30px;
    border: 1px solid #707070;
    width: 297px;
    color: $primary-black;
    span {
      font-size: 14px;
    }
    .title {
      height: 57px;
      background-color: #243782;
      color: $primary-white;
      padding-left: 30px;
      font-weight: bold;
    }
    ul {
      padding: 20px 30px 25px;
      margin: 0px;
      li {
        font-size: 14px;
        margin-bottom: 5px;
      }
      li:last-child {
        margin: 0px;
      }
      span {
        font-weight: bold;
      }
    }
    .dealer-details {
      li {
        ul {
          list-style-type: disc;
          padding: 5px 20px 0px;
        }
      }
    }
    .user-details {
      padding: 0px 30px 30px;
    }
  }
  .step-number {
    font-size: 14px;
    color: #282b34;
    margin-bottom: 30px;
    display: block;
    opacity: 0.5;
  }
  .section-label {
    color: $primary-black;
    font-size: 15px;
    text-transform: uppercase;
    margin-bottom: 20px;
    display: block;
    font-weight: bold;
  }
  .multiselect {
    width: 289px !important;
  }
  .custom-input {
    border: 1px solid #d1d1d1;
    width: 289px;
    height: 47px;
    justify-content: space-between;
    input {
      border: none;
      padding: 0px 15px;
      height: 100%;
    }
    .custom-input-buttons {
      padding: 0px 15px;
      align-items: center;
      .separator {
        color: #d1d1d1;
        margin: 0px 7.5px;
      }
      .edit-button {
        font-size: 14px;
        color: #243882;
        cursor: pointer;
      }
      .disabled {
        opacity: 0.7;
        cursor: default;
        pointer-events: none;
      }
    }
  }
  .cancel-button {
    margin-right: 0px !important;
  }
  .page1,
  .page2,
  .page3,
  .page4 {
    margin-top: 10px;
  }
  input {
    height: 46px;
    width: 349px;
  }
  .button-container {
    justify-content: space-between;
  }
  text-align: left;
  span {
    font-size: 24px;
  }
  .required {
    border: 1px solid red !important;
  }
  .user-type {
    .custom-input {
      margin-bottom: 10px;
    }
    .entity {
      margin-top: 24px;
      input {
        margin: 0px;
      }
    }
    .attribute-selection {
      margin-top: 25px;
    }
  }
  .user-details {
    ul {
      margin: 0px;
      li:nth-child(odd) {
        margin-bottom: 10px;
      }
      li:nth-child(even) {
        margin-bottom: 15px;
      }
      li {
        font-size: 15px;
        color: #282b34;
        input {
          height: 43px;
          width: 286px;
        }
        input.disabled {
          pointer-events: none;
          background: #d1d1d1;
          opacity: 0.58;
        }
      }
      li:last-child {
        margin-bottom: 0px;
      }
      .custom-input {
        width: 310px !important;
        input {
          height: 47px;
          width: 100%;
        }
      }
    }
    .submit-user-details {
      input {
        margin: 0px;
      }
      .separator {
        font-weight: lighter;
        color: $fca-gray;
        margin: 0px 5px;
      }
      .edit-button {
        color: #243882;
        text-transform: uppercase;
        cursor: pointer;
      }
      .edit-user-details {
        margin-top: 20px;
        .edit-button {
          font-size: 16px;
          font-weight: bold;
        }
        .disabled {
          opacity: 0.7;
          cursor: default;
          pointer-events: none;
        }
      }
    }
  }
  .request-details {
    #section-title {
      font-size: 15px;
      text-transform: uppercase;
      font-weight: bold;
      color: $primary-black;
      margin: 0px;
      display: block;
    }
    .current-roles-section {
      min-width: 230px;
      display: inline-block;
    }
    .lists {
      margin-top: 20px;
      padding: 25px 20px;
      border: 1px solid #d1d1d1;
      color: $primary-black;
      font-size: 14px;
      .domains-list {
        margin-right: 55px;
      }
      .roles-list {
        margin-right: 55px;
      }
      .bc-list {
        li {
          span {
            font-size: 14px;
          }
        }
      }
      .list-title {
        color: $primary-black;
        font-size: 14px;
        text-transform: uppercase;
        display: block;
        font-weight: bold;
        margin-bottom: 10px;
      }
      ul {
        margin: 0px;
        li {
          margin-bottom: 5px;
        }
        li:last-child {
          margin-bottom: 0px;
        }
      }
    }
    .section-label {
      font-size: 14px;
      margin: 25px 0px 20px;
    }
    .multiselect {
      margin-bottom: 10px;
    }
  }
  .role-selection {
    .multiselect {
      margin-top: 24px;
    }
    .input-box {
      width: 640px !important;
      margin-top: 24px;
      margin-bottom: 0px;
    }
    .action-change-role {
      p {
        padding: 15px 15px 0px 15px;
      }
    }
    .section-label-custom {
      font-size: 14px;
      color: $primary-black;
      text-transform: uppercase;
      margin: 25px 0px 20px;
      display: block;
      font-weight: bold;
    }
  }
}
.edit-request-container {
  text-align: left;
  span {
    font-size: 21px;
  }
  .action-title {
    display: block;
    margin-bottom: 9px;
  }
  .action-container {
    margin-top: 15px;
  }
  .role-type-dropdown {
    margin-top: 40px;
  }
  .request-details {
    ul {
      border: 1px solid #d1d1d1;
      margin: 0px;
      padding: 20px;
      width: 704px;
      li {
        font-size: 14px;
        color: $primary-black;
        margin-bottom: 15px;
        span {
          font-weight: bold;
          font-size: 14px;
        }
      }
      li:last-child {
        margin-bottom: 0px;
      }
    }
    p {
      font-size: 14px;
      margin: 0px;
    }
    .input-box {
      width: 640px !important;
      margin-top: 30px;
      margin-bottom: 25px;
    }
  }
  .section-label {
    color: $primary-black;
    font-size: 14px;
    text-transform: uppercase;
    margin: 25px 0px 20px;
    display: block;
    font-weight: bold;
  }
  .multiselect {
    width: 289px !important;
  }
  .action {
    p {
      font-size: 16px;
    }
  }
  .input-box {
    width: 704px !important;
    margin: 15px 0px 0px;
  }
  textarea {
    width: 633px !important;
    height: 159px !important;
    margin: 15px 0px 0px;
  }
  .action-change-role {
    p {
      padding: 10px 15px 0px 0px;
      font-size: 16px;
      margin: 0px;
    }
  }
}
.review-request-container {
  span {
    font-size: 21px;
  }
  text-align: left;
  .section-label {
    font-size: 14px;
    margin: 25px 0px 20px;
    color: $primary-black;
    text-transform: uppercase;
    display: block;
    font-weight: bold;
  }
  .radio-container {
    margin: 0px 25px 0px 0px;
  }
  .multiselect {
    margin-top: 25px;
  }
  .user-details {
    margin-top: 20px;
    input {
      width: 275px;
      margin-bottom: 20px;
    }
  }
  .request-details {
    ul {
      border: 1px solid #d1d1d1;
      margin: 0px;
      padding: 20px;
      width: 704px;
      li {
        font-size: 14px;
        color: $primary-black;
        margin-bottom: 15px;
        span {
          font-weight: bold;
          font-size: 14px;
        }
      }
      li:last-child {
        margin-bottom: 0px;
      }
    }
    p {
      font-size: 14px;
      margin: 0px;
    }
    .input-box {
      width: 640px !important;
      margin-top: 30px;
      margin-bottom: 25px;
    }
  }
}
.modal-button-container {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  .submit {
    margin-right: 20px;
  }
  margin-top: 35px;
}
.modal-body {
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  .modal-content {
    width: 100%;
    text-align: center;
  }
  .modal-title {
    font-size: 20px;
    text-transform: uppercase;
    font-weight: bold;
    display: block;
    margin-bottom: 20px;
  }
  .modal-text {
    font-size: 14px;
    color: $primary-black;
    display: block;
  }
}
.request-list {
  justify-content: space-between;
  align-items: center;
  margin: 0px 0px 35px 0px;
  .title {
    margin: 0px;
  }
}
.details {
  p {
    margin-bottom: 24px;
    margin-top: 0px;
  }
  color: $primary-black;
  ul {
    padding-left: 0px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;

    li {
      margin-top: 15px;
      span {
        font-size: inherit;
        font-family: 'Encode Sans Expanded', sans-serif;
        font-weight: medium;
      }
    }
    li:first-child {
      margin-top: 0px !important;
    }
  }
}
.current-roles {
  p {
    margin-bottom: 30px;
    margin-top: 0px;
  }
  color: $primary-black;
  ul {
    margin-top: 0px;
    margin-bottom: 0px;
    li {
      margin-top: 15px;
    }
    li:first-child {
      margin-top: 0px !important;
    }
    padding-left: 0px;
    span {
      font-size: inherit;
      font-family: 'Encode Sans Expanded', sans-serif;
      font-weight: medium;
    }
  }
  border-left: 2px solid $fca-gray;
  margin-left: 51.5px;
  padding-left: 40.5px;
}
#cancel-add-request {
  color: #243882;
  background-color: $primary-white;
  padding: 0px !important;
  margin: 0px !important;
  width: 0px;
  font-weight: bold;
}
.request-actions {
  border-top: 1px solid #d1d1d1;
  margin-top: 30px;
  padding-top: 30px;
  ul {
    margin-top: 25px !important;
  }
}
.details-by-domains {
  flex-wrap: wrap;
  ul {
    margin-right: 30px;
  }
}
</style>
